import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Gracias from "./pages/Gracias";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/gracias" element={<Gracias />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
